import { useEffect, useRef, useState } from "react";

export const useDelayedLoading = (
  isLoading: boolean,
  delayMs: number,
  minVisibleMs: number
): boolean => {
  const [isVisible, setIsVisible] = useState(false);
  const shownAtRef = useRef<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      const showTimer = setTimeout(() => {
        shownAtRef.current = Date.now();
        setIsVisible(true);
      }, delayMs);

      return () => clearTimeout(showTimer);
    }

    if (!isVisible) return;

    const shownFor = Date.now() - (shownAtRef.current || Date.now());
    const hideTimer = setTimeout(
      () => setIsVisible(false),
      Math.max(0, minVisibleMs - shownFor)
    );

    return () => clearTimeout(hideTimer);
  }, [isLoading, isVisible, delayMs, minVisibleMs]);

  return isVisible;
};
